import { SidebarProvider } from "../shadcn/components/ui/Sidebar";
import { Topbar } from "../Component/dashboard/Topbar";
import { DashboardSidebar as Sidebar } from "../Component/Non-Pofit/Sidebar";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ProfileForm from "../Component/Non-Pofit/Profile/Profile";
import PostForm from "../Component/serviceProvider dashboard/PostService/Postservice";
import { Applications } from "../Component/Non-Pofit/Application/Applications";
import { MessageBoard } from "../Component/Non-Pofit/Messages/MessageBoard";
import { Accounting } from "../Component/serviceProvider dashboard/Accounting/Accounting";
import { HelpAndSupport } from "../Component/dashboard/Help&Support/HelpSupport";
import { IndustryRelations } from "../Component/serviceProvider dashboard/IndustryRelations/IndustryRelations";
import { LiveChat } from "../Component/Non-Pofit/Messages/LiveChat";
import MyPropertiesServices from "../Component/Non-Pofit/MyPropertiesServices/MyPropertiesServices";
import PropertyForm from "../Component/dashboard/Propertyform/Propertyform";
import ServiceInfoform from "../Component/serviceProvider dashboard/serviceinfo/Serviceinfo";
import FilledLeaseForm from "../Component/Non-Pofit/Application/Filledleaseform";
import FilledRentalApplication from "../Component/Non-Pofit/Application/Filledrentalform";
import Transportform from "../Component/serviceProvider dashboard/Transport/Transport";
import { CorporateMessages } from "../Component/Non-Pofit/Messages/CorporateMessages";
import Transportationedit from "../Component/Non-Pofit/Transportation/Transportedit";
import ServiceInfoedit from "../Component/Non-Pofit/ServicesInfo/Serviceinfoedit";
import MyProperties from "../Component/PropertyOwnerDashboard/MyProperties/MyProperties";
import Notification from "../Component/Notification";
import { Navigate } from "react-router-dom";

// Define the tabs available for Nonprofit Dashboard
const NONPROFIT_TABS = [
  "My profile",
  "services",
  "properties",
  "application",
  "messages",
  "accounting",
  "Corporate Tickets",
  "Industry Relations",
  "MyPropertyServices",
  "Notification",
  "Property",
  "Serviceinfoform",
  "Transportation",
  "Post a Service/Property",
];

export function NonprofitDashboard() {
  const { section } = useParams();
  const [isOpen, setIsOpen] = useState(window.innerWidth > 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth > 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  // Validate the section exists in our tabs
  const isValidSection = NONPROFIT_TABS.includes(section);

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <Sidebar
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          tabs={NONPROFIT_TABS} // Pass the tabs to Sidebar
          currentSection={section}
        />
        <div className={`flex-1 flex flex-col`}>
          <Topbar section={section} />
          <main className="flex-1 overflow-auto p-4">
            {!isValidSection && (
              <Navigate to="/501 C3 Corporations/My profile" replace />
            )}

            {section === "Notification" && <Notification />}
            {section === "My profile" && <ProfileForm />}
            {section === "services" && <PostForm />}
            {section === "properties" && <MyProperties />}
            {section === "application" && <Applications />}
            {section === "messages" && <CorporateMessages />}
            {section === "accounting" && <Accounting />}
            {section === "Corporate Tickets" && <HelpAndSupport />}
            {section === "Industry Relations" && <IndustryRelations />}
            {section === "MyPropertyServices" && <MyPropertiesServices />}
            {section === "Property" && <PropertyForm />}
            {section === "Serviceinfoform" && <ServiceInfoform />}
            {section === "Transportation" && <Transportform />}
            {/* Additional routes that might need IDs */}

            {section === "livechat" && <LiveChat />}
            {section === "filledlease" && <FilledLeaseForm />}
            {section === "filledrental" && <FilledRentalApplication />}

            {section === "Transportations" && <Transportationedit />}
            {section === "Service Information" && <ServiceInfoform />}
            {section === "ServicesInfo" && <ServiceInfoedit />}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
